module.exports = __webpack_public_path__ + "img/Icon_mail.1105da9e.svg";